import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface TrendChipProps {
  value: number;
  unit?: string;
  showZeroAsNeutral?: boolean;
}

export default function TrendChip({ value, unit = '%', showZeroAsNeutral = true }: TrendChipProps) {
  if (showZeroAsNeutral && value === 0) {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs text-text-tertiary">
        <Minus size={12} />
        <span>0{unit}</span>
      </span>
    );
  }

  if (value > 0) {
    return (
      <span className="inline-flex items-center gap-0.5 text-xs font-medium text-success">
        <TrendingUp size={12} />
        <span>+{value}{unit}</span>
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-0.5 text-xs font-medium text-danger">
      <TrendingDown size={12} />
      <span>{value}{unit}</span>
    </span>
  );
}
